import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import $ from "jquery";
import SideMenu from "../Pages/SideMenu";
import Footer from "../Pages/Footer";
import Header from "../Pages/Header";
import Logout from "../Pages/Logout";
import { strings } from "../Utilities/strings";
import Loader from "../Utilities/Loader";
import * as XLSX from "xlsx";
// for Sidebar And Navbar
//for fontawesome icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Add_Icon from "../images/Add_Icon.svg";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  faEdit,
  faTrash,
  faPlus,
  fatrash,
} from "@fortawesome/free-solid-svg-icons";
//for data table
import { Table, Thead, Tbody, Tr, Th, Td } from "react-super-responsive-table";
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css";
//for modal
import "bootstrap/dist/css/bootstrap.min.css";
import { Button, Modal } from "react-bootstrap";
import Login from "../Login";
import {
  FarmOperation_getMasters,
  rmActivity,
  RmhistoryGet,
  deleteActivity,
  getFileByPath,
} from "../Utilities/URLCONSTANTS";
import { GetApiHeaders, GetApiHeadersWithToken, GetMediaImageBlobUrl, GetMediaImageUrl, ProtectedImage } from "../Utilities/NetworkUtilities";
import closedProducts from "../images/closed-products.png";
import delete_icon from "../images/ic_delete.png";
import user from "../images/user.png";
import productrequestImage from "../images/product_request.png";
import issuedProducts from "../images/issued-products.png";
import PendingProducts from "../images/Pending_products.png";
// import Delete from "../images/ic_delete.png";
import Delete from "../images/deleat_icon.svg";
import Edit_Icon from "../images/edit_icon.svg";
import { date } from "yup";
import moment from "moment";
import UploadFile from "../images/uploadfile.png";
import { CustomDatePickerInput, customstyles, CustomTimePickerInput, modalCustomStyles } from "../Utilities/utils";
import Select from "react-select";
import searchIcon from "../images/search_icon.svg";
import {
  HiMiniArrowsUpDown,
  HiMiniArrowUp,
  HiMiniArrowDown,
} from "react-icons/hi2";
import Pagination from "../Utilities/Pagination";

//ProductMaster

const FarmOperationsTractors = ({ }) => {
  const [loaderImage, setLoaderImage] = useState(
    require("../images/fo_loader.gif")
  );
  const [submitResponse, setsubmitResponse] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showResponsePopup, setShowResponsePopup] = useState(false);
  const [id, setId] = useState("");
  const [selectedLocation, setSelectedLocation] = useState("");
  const [locationDropDownData, setlocationDropDownData] = useState([]);
  const [getTractorData, setGetTractorData] = useState([]);
  const [selectedRegistrationNo, setSelectedRegistrationNo] = useState([]);
  const [serviceId, setServiceId] = useState("");
  const [date, setDate] = useState("");
  const [tractorsID, setTractorsID] = useState("");
  const [tractorType, setTractorType] = useState("");
  const [registrationNo, setRegistrationNo] = useState("");
  const [spares, setSpares] = useState("");
  const [fuel, setfuel] = useState("");
  const [cost, setCost] = useState("");
  const [startTime, setStartTime] = useState();
  const [endTime, setEndTime] = useState();
  const [remarks, setRemarks] = useState("");
  const [error, setError] = useState("");
  const [errstartTime, setErrStartTime] = useState("");
  const [errendTime, setErrEndTime] = useState("");
  const [errtractorsID, setErrTractorsID] = useState("");
  const [errregistrationNo, setErrRegistrationNo] = useState("");
  const [errorService, setErrorService] = useState("");
  const [errorTractorType, setErrorTractorType] = useState("");
  const [Errorlocation, setErrorlocation] = useState("");
  const [ErrorSprayersID, setErrorSprayersID] = useState("");
  const [Errorspares, setErrorSpares] = useState("");
  const [Errorfuel, setErrorfuel] = useState("");
  const [errorcost, setErrorCost] = useState("");
  const [errorremarks, setErrorRemarks] = useState("");
  const [errorDate, setErrorDate] = useState("");
  const [buttonText, setButtonText] = useState("Submit");
  const [showPopup, setShowPopup] = useState(false);
  const [errorETime, setErrorETime] = useState("");
  const [errorSTime, setErrorSTime] = useState("");
  const [popupText, setPopupText] = useState(
    "Do you want to close Spray Service"
  );
  const [getActivityType, setGetActivityType] = useState([]);
  const [showMsg, setShowMsg] = useState("false");
  ///modal popup
  const [showModal, setShowModal] = useState(false);
  const [TractorList, setTractorList] = useState([]);
  const [modalData, setModalData] = useState({
    serverRecordId: "",
    activityType: "",
    requiredDate: "",
    locationId: "",
    tractorType: "",
    locationName: "",
    registrationNo: "",
    service: "",
    tractorsID: "",
    repair: "",
    cost: "",
    startTime: "",
    endTime: "",
    remarks: "",
    submittedDate: "",
  });

  const [isUpdate, setIsUpdate] = useState(null);
  console.log("isUpdate", isUpdate);
  const [data, setData] = useState([]);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isUpdated, setIsUpdated] = useState(false);
  const [isUserLoggedIn, setIsUserLoggedIn] = useState("");
  const [showWarningPopup, setShowWarningPopup] = useState(false);

  const [filteredData, setFilteredData] = useState([]); // For filtered results
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10); // Default: 10 items per page
  const [searchTerm, setSearchTerm] = useState("");
  const [totalItems, setTotalItems] = useState();
  const [locationDropDownDataOriginal, setlocationDropDownDataOriginal] =
    useState([]);
  const [TractorRego, setTracterRegno] = useState();
  const [selectedLocationIdName, setSelectedLocationIdName] = useState();
  const [tractorArray, setTractorArray] = useState([]);
  const [tractorTypeIdName, setTractorTypeIdName] = useState();
  const [profilePicUrlShow, setProfilePicUrlShow] = useState([]);
  const [profilePicUrl, setProfilePicUrl] = useState([]);
  const [meterReading, setMeterReading] = useState([]);

  // const totalItems = filteredData.length;
  // In your handleFilter function, update filteredData based on searchTerm
  const handleFilter = (searchTerm) => {
    setSearchTerm(searchTerm);
    if (data != null && data != undefined) {
      const filteredResults = data.filter((item) => {
        return (
          item.requiredDate.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.locationName.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.service.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.tractorTypeId.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.tractorTypeName
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          item.repair.toLowerCase().includes(searchTerm.toLowerCase()) ||
          item.cost
            .toString()
            .toLowerCase()
            .includes(searchTerm.toLowerCase()) ||
          item.remarks.toLowerCase().includes(searchTerm.toLowerCase())
        );
      });
      setFilteredData(filteredResults);
      handlePageClick(1);
      console.log("searchTerm", filteredData);
    }
  };
  useEffect(() => {
    if (data != null && data != undefined) {
      //  const totalItems = data.length;
      setFilteredData(data);
      setTotalItems(data.length);
    }
  }, [data]);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  // Pagination logic
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  // const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  const handleItemsPerPageChange = (e) => {
    const selectedValue = parseInt(e.target.value);
    setItemsPerPage(selectedValue);
    setCurrentPage(1); // Reset to the first page when changing items per page.
  };

  // const totalItems = data.length;

  const pageNumbers = [];
  for (
    let i = Math.max(2, currentPage - 1);
    i <= Math.min(Math.ceil(totalItems / itemsPerPage) - 1, currentPage + 1);
    i++
  ) {
    pageNumbers.push(i);
  }
  const handlePageClick = (pageNumber) => {
    if (pageNumber >= 1 && pageNumber <= Math.ceil(totalItems / itemsPerPage)) {
      setCurrentPage(pageNumber);
    }
  };
  const exportToExcel = () => {
    const data = [
      [
        "S.no",
        "Required Date",
        "Location Name",
        "Tractor Type Name",
        "Registraion No",
        "Service",
        "Spares",
        "MeterReading",
        "Fuel",
        "Start Time",
        "End Time",
        "Cost",
        "Remarks",
      ], // Custom headers
      // ...currentItems.map((item) => [
      ...filteredData.map((item, index) => [
        index + 1,
        item.requiredDate,
        item.locationName,
        item.tractorTypeName,
        item.registrationNumber,
        item.service,
        item.spares,
        item.meterReading,
        item.fuel,
        item.startTime,
        item.endTime,
        item.cost,
        item.remarks,
      ]),
    ];
    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "FarmOperations-Tractors");
    // Save the file
    XLSX.writeFile(wb, "FarmOperations-Tractors.xlsx");
  };
  const handleCancel_new = () => {
    setShowModal(true);
    setShowPopup(true);
  };
  const handleCancel = () => {
    //no
    setShowModal(true);
    setShowPopup(false);
  };
  const handleClose = () => {
    //yes
    setShowPopup(false);
    setShowModal(false);
    window.location.reload();
  };
  const handlelocationChange = (e) => {
    setSelectedLocation(e.target.value);
    setErrorlocation(""); // Clear error when a valid selection is made

    const TractorsArray = [];
    const locationsID =
      e.target.options[e.target.selectedIndex].getAttribute("data-locationId");
    setSelectedLocationIdName(locationsID);
    getTractorData.find((item) => {
      if (item.locationId === locationsID || item.locationId === "0") {
        TractorsArray.push(item);
      }
    });
    setTractorList(TractorsArray);
  };
  const handleClear = () => {
    setSearchTerm("");
  };


  const handleTractorType = (selectedOption) => {
    setIsUpdate(false);

    if (!selectedOption) {
      setTractorType("");
      setTractorTypeIdName("");
      setTracterRegno("");
      return;
    }

    setTractorType(selectedOption.value);
    setTractorTypeIdName(selectedOption.tractorIdName);
    setTracterRegno(selectedOption.regno);
    setErrorTractorType("");
  };

  const handleServiceChange = (e) => {
    const input = e.target.value;
    const result = input.replace(/[^a-z_\s]/gi, "");
    setServiceId(result);
    // if (input) {
    //   setErrorService("");
    // }
  };
  const handleRegistraionNoChange = (e) => {
    const input = e.target.value;

    setRegistrationNo(input);
  };
  const handleTractorsIDChange = (e) => {
    const input = e.target.value;
    //const result = input.replace(/[^a-z_\s]/gi, '');
    setTractorsID(input);
    if (input) {
      setErrTractorsID("");
    }
  };
  const handleStartTime = (e) => {
    const newStartTime = e.target.value;
    setStartTime(newStartTime);
    setErrStartTime("");

    // Check if both start and end times are selected
    if (newStartTime && endTime) {
      validateTime(newStartTime, endTime);
    }
  };
  const handleEndTime = (e) => {
    const newEndTime = e.target.value;
    setEndTime(newEndTime);
    setErrEndTime("");

    // Check if both start and end times are selected
    if (startTime && newEndTime) {
      validateTime(startTime, newEndTime);
    }
  };
  const validateTime = (start, end) => {
    const startTimeObj = new Date(`2000-01-01T${start}`);
    const endTimeObj = new Date(`2000-01-01T${end}`);

    if (startTimeObj >= endTimeObj) {
      // setErrorSTime("Start time must be earlier than end time");
      setErrorETime("End time must be later than start time");
    } else {
      setErrorSTime("");
      setErrorETime("");
    }
  };
  const handledateChange = (e) => {
    const selectedDate = e.target.value;
    setDate(selectedDate);
    if (selectedDate) {
      setErrorDate("");
    }
  };
  const parseLocalDate = (dateString) => {
    if (!dateString) return null;

    const [year, month, day] = dateString.split("-").map(Number);
    return new Date(year, month - 1, day);
  };

  const handleSparesChange = (e) => {
    const inputSpares = e.target.value;
    setSpares(inputSpares);
  };
  // const handleImageClick = (imageUrl) => {
  //   window.open(imageUrl, "_blank");
  // };


  const handleImageClick = async (request) => {
    if (!request?.imagePath) {
      console.error("Image path is missing");
      return;
    }
    try {
      let blobUrl = "";
      // Complete Media API URL
      if (request.imagePath.startsWith("https")) {
        blobUrl = await GetMediaImageBlobUrl(request.imagePath);
      }
      // Only image path
      else {
        blobUrl = await GetMediaImageUrl(
          getFileByPath,
          request.imagePath
        );
      }

      if (!blobUrl) {
        console.error("Unable to load image");
        return;
      }
      const newWindow = window.open("", "_blank");
      if (!newWindow) {
        console.error("Popup blocked by browser");
        URL.revokeObjectURL(blobUrl);
        return;
      }
      newWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Image</title>
          <style>
            html, body {
              margin: 0;
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
              background: #f5f5f5;
            }

            img {
              max-width: 90%;
              max-height: 90%;
              object-fit: contain;
            }
          </style>
        </head>

        <body>
          <img src="${blobUrl}" alt="Image" />
        </body>
      </html>
    `);

      newWindow.document.close();

    } catch (error) {
      console.error("Image loading failed:", error);
    }
  };



  const handlefuelChange = (e) => {
    const inputfuel = e.target.value;
    setfuel(inputfuel);
    if (!isNaN(inputfuel)) {
      setfuel(inputfuel);
    }
    if (inputfuel) {
      setErrorfuel("");
    }
  };
  const handleCostChange = (e) => {
    const inputunitCost = e.target.value;
    if (!isNaN(inputunitCost)) {
      setCost(inputunitCost);
    }
    if (inputunitCost) {
      setErrorCost("");
    }
  };
  const handleRemarksChange = (e) => {
    setRemarks(e.target.value);
  };

  const handleresponse = () => {
    setShowResponsePopup(false);
    setShowWarningPopup(false);
    setShowPopup(false);
    setShowModal(false);
    window.location.reload();
  };
  const handleSubmit = async (index) => {
    const apiUrl = rmActivity;
    const headers = await GetApiHeaders();
    const dataToSend = {
      serverRecordId: { buttonText } == "Submit" ? 0 : parseInt(id),
      activityType: getActivityType?.[3]?.name || "",
      requiredDate: moment.utc(date).format("YYYY-MM-DD HH:mm:ss.SSS"),
      locationId: selectedLocationIdName,
      locationName: selectedLocation,
      tractorTypeName: tractorType,
      tractorTypeId: tractorTypeIdName,
      service: serviceId,
      registrationNumber: registrationNo ? registrationNo : TractorRego,
      spares: spares,
      meterReading: meterReading,
      cost: parseInt(cost),
      startTime: startTime,
      imageList:
        profilePicUrl && profilePicUrl.toString().length > 0
          ? profilePicUrl
            .toString()
            .split(",")
            .map((img) => img.trim())
            .filter((img) => img.length > 0) // Remove empty values
            .map((img) => ({ image: img })) // Convert to object format
          : [],
      endTime: endTime,
      remarks: remarks,
      fuel: parseInt(fuel),
      submittedDate: moment.utc(date).format("YYYY-MM-DD HH:mm:ss.SSS"), //moment(date, "YYYY-MM-DD HH:mm:ss.SSS")  //date
    };

    try {
      // if (cost   && spares  && tractorsID  &&
      // date  && serviceId  && selectedLocation   && fuel  && cost ) {
      if (
        cost !== "" &&
        selectedLocation != "" &&
        date != "" &&
        tractorType != "" &&
        fuel != "" &&
        startTime != "" &&
        endTime != ""
      ) {
        setIsLoading(true);
        const response = await axios.post(apiUrl, dataToSend, { headers });
        console.log("response submit:: ", response);
        setsubmitResponse(response.data.message);
        setShowModal(false);
        setShowResponsePopup(true);
        setIsLoading(false);

        setIsSubmitted(true);
      } else {
        setErrorlocation(
          selectedLocation === "" ? "Please Select a Location" : ""
        );
        setErrorTractorType(
          tractorType === "" ? "Please Select Tractor Type" : ""
        );
        // setErrorService(serviceId === "" ? "Please Enter a Service" : "");
        // setErrorSpares(spares === "" ? "Please Enter Spares" : "");
        setErrorDate(date === "" ? "Please Enter a Date" : "");
        setErrorCost(cost === "" ? "Please Enter Cost" : "");
        setErrorfuel(fuel === "" ? "Please Enter Fuel" : "");
        // setErrEndTime(endTime === "" ? "Please Select End Time" : "");
        if (!endTime) {
          setErrEndTime("Please Select End Time");
        } else {
          setErrEndTime("");
        }
        // setErrStartTime(startTime === "" ? "Please Select Start Time" : "");
        setErrStartTime(!startTime ? "Please Select Start Time" : "");
      }
    } catch (error) {
      console.error("Error:", error);
      // setIsSubmitted(false);
    }
  };

  const fetchData = async () => {
    const apiUrl = RmhistoryGet;
    const headers = await GetApiHeaders();
    const getDataObject = {
      activityType: "tractors",
      endDate: "",
      mobileNumber: headers.mobileNumber,
      startDate: "",
      userId: headers.userId,
    };

    setIsLoading(true);
    axios
      .post(apiUrl, getDataObject, { headers })
      .then((response) => {
        console.log(
          "main table response ::;;",
          JSON.stringify(response.data.response.rmHistory)
        );
        setData(response.data.response.rmHistory);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error("Error fetching data:", error);
      });
  };
  //for data table
  const tableRef = useRef(null);
  useEffect(() => {
    // Check if DataTable is already initialized
    if ($.fn.DataTable.isDataTable(tableRef.current)) {
      // Destroy the existing DataTable instance
      $(tableRef.current).DataTable().destroy();
    }

    // Initialize the DataTable
    $(tableRef.current).DataTable({
      ordering: false, // Disable sorting
    });
    fetchData();
    fetchLocationDropdownData();
    fetchTractorData();
  }, [modalData]);
  const handleModalOpen = () => {
    if (locationDropDownDataOriginal.length > 0) {
      const uniqueLocationNames = new Set();
      const uniqueDripSystemMaster = locationDropDownDataOriginal.filter(
        (item) => {
          if (!uniqueLocationNames.has(item.locationName)) {
            uniqueLocationNames.add(item.locationName);
            return true;
          }
          return false;
        }
      );
      setlocationDropDownData(uniqueDripSystemMaster);
    }
    setIsUpdate(false);
    console.log("isUpdate", isUpdate);
    setButtonText("Submit");
    setIsSubmitted(false);
    setIsUpdated(false);
    setShowModal(true);
    setId(0);
    setSelectedLocation("");
    setServiceId("");
    setTractorsID("");
    setSpares("");
    setfuel("");
    setCost("");
    setRemarks("");
    setDate("");
    setModalData({
      id: "",
      activityType: "",
      requiredDate: "",
      locationId: "",
      locationName: "",
      tractorTypeId: "",
      registrationNumber: "",
      tractorTypeName: "",
      service: "",
      SprayersID: "",
      repair: "",
      cost: "",
      startTime: "",
      endTime: "",
      remarks: "",
      submittedDate: "",
      serverRecordId: "",
    });
  };
  const handleModalClose = () => {
    setShowPopup(false);
    setShowModal(false);

    setShowWarningPopup(false);
    window.location.reload();
  };
  const fetchLocationDropdownData = async () => {
    const apiUrl = FarmOperation_getMasters;
    const headers = await GetApiHeaders();
    axios
      .get(apiUrl, { headers })
      .then((response) => {
        console.log("responseLocation", response.data.response.subSiteMaster);
        setlocationDropDownDataOriginal(response.data.response.subSiteMaster);
        setSelectedRegistrationNo(response.data.response.tractorMaster);
        setGetActivityType(response.data.response.rmActivitiesMaster);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };
  const fetchTractorData = async () => {
    const apiUrl = FarmOperation_getMasters;
    const headers = await GetApiHeaders();
    axios
      .get(apiUrl, { headers })
      .then((response) => {
        console.log("responseLocation", response);
        setGetTractorData(response.data.response.tractorMaster);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  };

  const getImageBase64 = async (imagePath) => {
    try {
      const fileServerAuthCode = await GetApiHeadersWithToken();
      const response = await axios.get(
        `${getFileByPath}?imagePath=${encodeURIComponent(imagePath)}`,
        {
          headers: {
            fileServerAuthCode: fileServerAuthCode,
          },
          responseType: "blob",
        }
      );
      return await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64 = reader.result.split(",")[1];
          resolve(base64);
        };
        reader.onerror = reject;
        reader.readAsDataURL(response.data);
      });
    } catch (error) {
      console.error("Error converting image to Base64:", error);
      return "";
    }
  };
  const [selectedLocationOption, setSelectedLocationOption] = useState("");
  const updatedItems = async (item) => {
    console.log("items", item);
    setSelectedLocationOption(item.locationName);
    setlocationDropDownData(locationDropDownDataOriginal);
    setTractorList(getTractorData);
    if (locationDropDownDataOriginal.length > 0) {
      const uniqueLocationNames = new Set();
      const uniqueDripSystemMaster = locationDropDownDataOriginal.filter(
        (item) => {
          if (!uniqueLocationNames.has(item.locationName)) {
            uniqueLocationNames.add(item.locationName);
            return true;
          }
          return false;
        }
      );
      setlocationDropDownData(uniqueDripSystemMaster);
    }
    setIsUpdate(true);
    setModalData(item);
    setId(item.serverRecordId);
    setDate(
      item.submittedDate !== "" && item.submittedDate !== null
        ? item.submittedDate.toString().split(" ")[0]
        : ""
    );
    setSelectedLocation(item.locationName);
    setServiceId(item.service);
    setRegistrationNo(item.registrationNumber);
    setSpares(item.spares);
    setMeterReading(item.meterReading);
    setfuel(item.fuel);
    setCost(item.cost);
    setStartTime(item.startTime);
    setTractorType(item.tractorTypeName);
    setEndTime(item.endTime);
    setRemarks(item.remarks);
    // setProfilePicUrlShow(item.image);
    // setProfilePicUrl(item.image);

    if (item.image?.length > 0) {
      const imagePaths = item.image
        .map((path) => {
          if (!path) return "";
          let cleanPath = path.trim();
          // If complete Media API URL is received
          if (cleanPath.includes("?imagePath=")) {
            cleanPath = cleanPath.split("?imagePath=")[1];
          }
          try {
            cleanPath = decodeURIComponent(cleanPath);
          } catch (error) {
            // Keep original value
          }
          return cleanPath.trim();
        })
        .filter(Boolean);
      console.log("Final image paths:", imagePaths);
      // Convert existing server images to Base64
      const base64Images = await Promise.all(
        imagePaths.map((imagePath) =>
          getImageBase64(imagePath)
        )
      );
      console.log("Base64 images:", base64Images);
      // This will be used by your existing handleSubmit
      setProfilePicUrl(base64Images.filter(Boolean));
      // Load images for popup preview
      const imageUrls = await Promise.all(
        imagePaths.map((imagePath) =>
          GetMediaImageUrl(getFileByPath, imagePath)
        )
      );
      console.log("Popup image URLs:", imageUrls);
      setProfilePicUrlShow(imageUrls.filter(Boolean));
    } else {
      setProfilePicUrlShow([]);
      setProfilePicUrl([]);
    }
    setShowModal(true);
    setButtonText("Update");
    setIsSubmitted(false);
    setIsUpdated(false);
  };
  const closeWarning = () => {
    setShowWarningPopup(true);
  };
  const deleteItem = async (item) => {
    // alert(JSON.stringify(item));
    const apiUrl = deleteActivity;
    const headers = await GetApiHeaders();

    const dataToSend = {
      id: item.serverRecordId,
    };
    //alert(JSON.stringify(dataToSend));
    // Make the POST request using Axios with headers
    setIsLoading(true);
    const response = await axios.post(apiUrl, dataToSend, { headers });
    console.log("response submit:: ", response);
    setsubmitResponse(response.data.message);
    setShowResponsePopup(true);
    setIsLoading(false);
  };

  const setMinDateToToday = () => {
    const today = new Date();
    const yyyy = today.getFullYear();
    const mm = String(today.getMonth() + 1).padStart(2, "0");
    const dd = String(today.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
  };
  const handleFileChange = (event) => {
    const selectedImages = event.target.files;

    if (selectedImages && selectedImages.length > 0) {
      const updatedProfilePicUrlShow = [];
      const updatedProfilePicUrl = [];

      Array.from(selectedImages).forEach((image, index) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const dataURL = reader.result;
          updatedProfilePicUrlShow[index] = dataURL;

          // Remove the data URL prefix
          const base64 = dataURL.split(",")[1];
          updatedProfilePicUrl[index] = base64;

          setProfilePicUrlShow([...updatedProfilePicUrlShow]);
          setProfilePicUrl([...updatedProfilePicUrl]);
        };

        reader.onerror = () => {
          // Handle error reading the selected image
        };

        reader.readAsDataURL(image);
      });
    } else {
      // No new images selected, retain existing image URLs
      // You might want to adjust this based on your specific use case
      setProfilePicUrlShow([...profilePicUrlShow]);
      setProfilePicUrl([...profilePicUrl]);
    }
  };

  const [sortConfig, setSortConfig] = useState({ key: null, direction: "asc" });
  const sortedData = [...filteredData].sort((a, b) => {
    if (sortConfig.key) {
      const aValue = a[sortConfig.key];
      const bValue = b[sortConfig.key];

      // Check if values are numeric
      if (!isNaN(aValue) && !isNaN(bValue)) {
        return sortConfig.direction === "asc" ? aValue - bValue : bValue - aValue;
      }

      // Fallback for string comparison
      const aString = aValue?.toString().toLowerCase();
      const bString = bValue?.toString().toLowerCase();
      if (aString < bString) return sortConfig.direction === "asc" ? -1 : 1;
      if (aString > bString) return sortConfig.direction === "asc" ? 1 : -1;
      return 0;
    }
    return 0;
  });

  // Handle column sorting
  const handleSort = (key) => {
    setSortConfig((prevConfig) => ({
      key,
      direction: prevConfig.key === key && prevConfig.direction === "asc" ? "desc" : "asc",
    }));
  };

  const renderSortIcon = (key) => {
    if (sortConfig.key !== key) {
      return <HiMiniArrowsUpDown className="ms-1" size={16} style={{ cursor: "pointer" }} />;
    }
    return sortConfig.direction === "asc" ? (
      <HiMiniArrowUp className="ms-1" size={16} style={{ cursor: "pointer" }} />
    ) : (
      <HiMiniArrowDown className="ms-1" size={16} style={{ cursor: "pointer" }} />
    );
  };
  const currentItems = sortedData.slice(indexOfFirstItem, indexOfLastItem);


  return (
    <body id="page-top">
      {/*  <!-- Page Wrapper --> */}
      <div id="wrapper">
        {/*  <!-- Sidebar --> */}
        <SideMenu />
        {/*  <!-- End of Sidebar --> */}

        {/*  <!-- Content Wrapper --> */}
        <div id="content-wrapper" className="d-flex flex-column">
          {/*  <!-- Main Content --> */}
          <div id="content">
            {/*  <!-- Topbar --> */}
            <Header />
            {/* ...Content Start... */}
            <div>
              <div className="container-fluid">
                <h5 className="Roles_text">Farm Operations</h5>
                <div>
                  <h5 className="mb-0 Sub_role_text">Tractors </h5>
                </div>
                <div className="card border-0">
                  <div className="card-body pt-0 pl-1">
                    <div className="d-flex justify-content-between">
                      <div>
                        <h5 className="mb-0 Sub_role_text"></h5>
                      </div>
                      <span
                        class="d-inline-block"
                        tabindex="0"
                        data-toggle="tooltip"
                        title="Add Tractors"
                      >
                        <Button
                          variant="primary"
                          className="buttons"
                          onClick={handleModalOpen}
                        >
                          {/* <FontAwesomeIcon
                            icon={faPlus}
                            className="plus_icon mr-1"
                          /> */}
                          <img
                            src={Add_Icon}
                            alt="Add"
                            className="addicon"
                          />
                          Add
                        </Button>
                      </span>
                    </div>
                    <div className="mcrc_hrline "></div>
                    <div>
                      <div
                        className="card flex-grow-1 "
                        style={{
                          border: "1px solid #0000001A",
                          boxShadow: "0 0.1rem 0.3rem rgba(0, 0, 0, 0.1)",
                        }}
                      >
                        <div className="card-body " style={{ padding: "20px" }}>
                          <div
                            className="d-flex justify-content-between align-items-center"
                            style={{ paddingBottom: 20 }}
                          >
                            <div className="d-flex align-items-center">
                              <label className="mr-1">Show </label>
                              <Select
                                options={[
                                  { value: 10, label: '10' },
                                  { value: 20, label: '20' },
                                  { value: 50, label: '50' },
                                ]}
                                value={{
                                  value: itemsPerPage,
                                  label: String(itemsPerPage),
                                }}
                                onChange={(selected) => {
                                  setItemsPerPage(selected.value);
                                  setCurrentPage(1);
                                }}
                                isSearchable={false}
                                styles={customstyles}
                              />

                              &nbsp;
                              <label> Entries</label>
                            </div>
                            <div className="d-flex align-items-center">
                              <div className="search-container">
                                <img
                                  src={searchIcon}
                                  alt="Search"
                                  className="search-icon"
                                />
                                <input
                                  type="text"
                                  placeholder="Type to Search..."
                                  value={searchTerm}
                                  onChange={(e) => handleFilter(e.target.value)}
                                  className="search-input mr-2"
                                />
                                {searchTerm && (
                                  <button
                                    type="button"
                                    className="search-clear-btn"
                                    onClick={() => handleFilter("")}
                                  >
                                    ×
                                  </button>
                                )}
                              </div>
                              &nbsp;
                              <button
                                className="btn btn-secondary buttons-excel buttons-html5 mb-0"
                                onClick={exportToExcel}
                              >
                                Download Excel
                              </button>
                            </div>

                          </div>
                          <div style={{ overflowX: "auto", width: "100%" }}>
                            <Table className="table table-bordered Content_data_table table-striped">
                              {" "}
                              <Thead>
                                <Tr>
                                  <Th className="text-center">S.No</Th>
                                  <Th
                                    className="text-center"
                                    onClick={() => handleSort("requiredDate")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Date
                                      {renderSortIcon("requiredDate")}
                                    </span>
                                  </Th>

                                  <Th
                                    className="text-center"
                                    onClick={() => handleSort("locationName")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Location
                                      {renderSortIcon("locationName")}
                                    </span>
                                  </Th>
                                  <Th
                                    className="text-center"
                                    onClick={() => handleSort("tractorTypeName")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Tractor Type
                                      {renderSortIcon("tractorTypeName")}
                                    </span>
                                  </Th>

                                  <Th
                                    className="text-center"
                                    onClick={() => handleSort("registrationNumber")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Registration No
                                      {renderSortIcon("registrationNumber")}
                                    </span>
                                  </Th>

                                  <Th
                                    className="text-center"
                                    onClick={() => handleSort("service")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Service
                                      {renderSortIcon("service")}
                                    </span>
                                  </Th>

                                  <Th
                                    className="text-center"
                                    onClick={() => handleSort("spares")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Spares
                                      {renderSortIcon("spares")}
                                    </span>
                                  </Th>

                                  <Th
                                    className="text-center"
                                    onClick={() => handleSort("meterReading")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      MeterReading
                                      {renderSortIcon("meterReading")}
                                    </span>
                                  </Th>

                                  <Th
                                    className="text-center"
                                    onClick={() => handleSort("fuel")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Fuel(in Liters)
                                      {renderSortIcon("fuel")}
                                    </span>
                                  </Th>

                                  <Th
                                    className="text-center"
                                    onClick={() => handleSort("cost")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Cost
                                      {renderSortIcon("cost")}
                                    </span>
                                  </Th>

                                  <Th
                                    className="text-center"
                                    onClick={() => handleSort("startTime")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Start Time
                                      {renderSortIcon("startTime")}
                                    </span>
                                  </Th>

                                  <Th
                                    className="text-center"
                                    onClick={() => handleSort("endTime")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      End Time
                                      {renderSortIcon("endTime")}
                                    </span>
                                  </Th>

                                  <Th
                                    className="text-center"
                                    onClick={() => handleSort("remarks")}
                                  >
                                    <span className="d-inline-flex align-items-center">
                                      Remarks
                                      {renderSortIcon("remarks")}
                                    </span>
                                  </Th>

                                  <Th className="text-center">Images</Th>
                                  <Th className="text-center">Actions</Th>
                                </Tr>
                              </Thead>
                              <Tbody>
                                {currentItems.length === 0 ? ( // Check if no data is found
                                  <Tr>
                                    <Td
                                      colSpan={13}
                                      className="text-center"
                                      style={{ padding: 190 }}
                                    >
                                      Data is not available
                                    </Td>
                                  </Tr>
                                ) : (
                                  currentItems.map((item, index) => {
                                    var requiredDate = moment(
                                      item.requiredDate
                                    ).format("DD-MMM-YYYY   ");

                                    return (
                                      <Tr>
                                        <Td className="text-left">
                                          {(currentPage - 1) * itemsPerPage +
                                            index +
                                            1}
                                        </Td>
                                        <Td className="text-left">
                                          {requiredDate}
                                        </Td>
                                        <Td className="text-left">
                                          {item.locationName}
                                        </Td>
                                        <Td className="text-left">
                                          {item.tractorTypeName}
                                        </Td>
                                        <Td className="text-left">
                                          {item.registrationNumber}
                                        </Td>
                                        <Td className="text-left">
                                          {item.service}
                                        </Td>
                                        <Td className="text-left">
                                          {item.spares}
                                        </Td>
                                        <Td className="text-left">
                                          {item.meterReading}
                                        </Td>
                                        <Td className="text-left">
                                          {item.fuel}
                                        </Td>
                                        <Td className="text-left">
                                          {item.cost}
                                        </Td>
                                        <Td className="text-left">
                                          {item.startTime}
                                        </Td>
                                        <Td className="text-left">
                                          {item.endTime}
                                        </Td>
                                        <Td className="text-right">
                                          {item.remarks}
                                        </Td>
                                        {/* <Td>
                                          {item.image.map((image, index) => (
                                            <img
                                              key={index}
                                              src={image}
                                              style={{
                                                width: "30px",
                                                height: "40px",
                                                cursor: "pointer",
                                                border: "1px solid black",
                                                marginRight: "5px",
                                              }}
                                              onClick={() =>
                                                handleImageClick(image)
                                              }
                                            />
                                          ))}
                                        </Td> */}

                                        {/* <Td>
                                          {item.image?.map((image, index) => {
                                            const imageUrl = image?.trim();

                                            if (!imageUrl) {
                                              return null;
                                            }

                                            return (
                                              <ProtectedImage
                                                key={index}
                                                imagePath={imageUrl}
                                                onClick={() =>
                                                  handleImageClick({
                                                    imagePath: imageUrl,
                                                  })
                                                }
                                              />
                                            );
                                          })}
                                        </Td> */}

                                        <Td>
                                          {item.image?.map((image, index) => {
                                            const imageUrl = image?.trim();

                                            if (!imageUrl) {
                                              return null;
                                            }

                                            return (
                                              <span
                                                key={index}                                              
                                                className="image-gap"
                                              >
                                                <ProtectedImage
                                                  imagePath={imageUrl}
                                                  onClick={() =>
                                                    handleImageClick({
                                                      imagePath: imageUrl,
                                                    })
                                                  }
                                                />
                                              </span>
                                            );
                                          })}
                                        </Td>
                                        <Td >
                                          <div className="d-flex justify-content-center align-items-center">
                                            <img
                                              src={Edit_Icon}
                                              alt="Edit"
                                              className="editicon mr-2"
                                              title="Edit User Master"
                                              onClick={() => updatedItems(item)}
                                            />
                                            <img
                                              src={Delete}
                                              alt="downloadImg"
                                              className="deleate_icon"
                                              onClick={() => deleteItem(item)}
                                            />
                                          </div>
                                        </Td>
                                      </Tr>
                                    );
                                  })
                                )}
                              </Tbody>
                              {isLoading && (
                                <Loader
                                  loading={isLoading}
                                  message={"Fetching Data. Please Wait..!"}
                                  loderimage={loaderImage}
                                />
                              )}
                            </Table>
                          </div>

                          {/* Pagination */}
                          <Pagination
                            currentPage={currentPage}
                            totalItems={sortedData.length}
                            itemsPerPage={itemsPerPage}
                            currentItems={currentItems}
                            onPageChange={handlePageClick}
                          />
                        </div>
                        <div>
                          <Modal
                            show={showModal}
                            onHide={handleModalClose}
                            centered
                            backdrop="static"
                            keyboard={false}
                            size="lg"
                          >
                            <Modal.Header className="border-0 d-flex justify-content-center">
                              <Modal.Title> </Modal.Title>
                              <Button
                                variant="link"
                                className="close btn btn-danger  close_btn"
                                onClick={handleCancel_new}
                              >
                                {" "}
                                {/*closeWarning */}X
                              </Button>
                            </Modal.Header>
                            <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                              <div className="d-flex justify-content-center mb-3 font-weight-600">
                                <span className="modal_title">Tractors</span>
                              </div>
                              <div className="row">

                                <div className="col-md-6 col-12 mt-2">
                                  <label
                                    htmlFor="exampleInputPassword1"
                                    className="form-label text-sm font-weight-600 mt-1"
                                  >
                                    Date <span style={{ color: "red" }}>*</span>
                                  </label>

                                  <div className="input-group input-group w-100">
                                    <DatePicker
                                      selected={date ? parseLocalDate(date) : null}
                                      onChange={(selectedDate) =>
                                        handledateChange({
                                          target: {
                                            value: selectedDate
                                              ? `${selectedDate.getFullYear()}-${String(
                                                selectedDate.getMonth() + 1
                                              ).padStart(2, "0")}-${String(
                                                selectedDate.getDate()
                                              ).padStart(2, "0")}`
                                              : "",
                                          },
                                        })
                                      }
                                      minDate={new Date(setMinDateToToday())}
                                      dateFormat="dd-MM-yyyy"
                                      placeholderText="Select Date"
                                      customInput={<CustomDatePickerInput placeholder="Select Date" />}
                                    />
                                  </div>

                                  <span style={{ color: "red" }}>
                                    {errorDate}
                                  </span>
                                </div>
                                <div className="col-md-6 col-12">
                                  <label
                                    for="InputName"
                                    className="form-label text-sm font-weight-600 mt-2"
                                  >
                                    Location{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>

                                  <Select
                                    inputId="dropdown"
                                    styles={modalCustomStyles}
                                    placeholder="Select Location Name"
                                    value={
                                      locationDropDownDataOriginal
                                        .map((item) => ({
                                          value: item.name,
                                          label: item.name,
                                          code: item.code,
                                        }))
                                        .find((option) => option.value === selectedLocation) || null
                                    }
                                    options={locationDropDownDataOriginal.map((item) => ({
                                      value: item.name,
                                      label: item.name,
                                      code: item.code,
                                    }))}
                                    onChange={(selectedOption) => {
                                      const options = selectedOption
                                        ? [{ getAttribute: () => selectedOption.code }]
                                        : [{ getAttribute: () => "" }];

                                      handlelocationChange({
                                        target: {
                                          value: selectedOption ? selectedOption.value : "",
                                          options: options,
                                          selectedIndex: 0,
                                        },
                                      });
                                    }}
                                    isClearable
                                  />
                                  <span style={{ color: "red" }}>
                                    {Errorlocation}
                                  </span>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-6 col-12">
                                  <label
                                    for="InputName"
                                    className="form-label text-sm font-weight-600 mt-1"
                                  >
                                    Tractor Type{" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>

                                  <Select
                                    inputId="dropdown"
                                    styles={modalCustomStyles}
                                    placeholder="Select Tractor Type"
                                    value={
                                      TractorList.map((item) => ({
                                        value: item.name,
                                        label: item.name,
                                        regno: item.tracRegistrationNo,
                                        tractorIdName: item.code,
                                      })).find((option) => option.value === tractorType) || null
                                    }
                                    options={TractorList.map((item) => ({
                                      value: item.name,
                                      label: item.name,
                                      regno: item.tracRegistrationNo,
                                      tractorIdName: item.code,
                                    }))}
                                    onChange={handleTractorType}
                                    isClearable
                                  />

                                  <span style={{ color: "red" }}>
                                    {errorTractorType}
                                  </span>

                                </div>

                                <div className="col-md-6 col-12">
                                  <label
                                    for="InputName"
                                    className="form-label text-sm font-weight-600 mt-1"
                                  >
                                    Registration No{" "}
                                    {/* <span style={{ color: "red" }}>*</span> */}
                                    {" "}
                                  </label>
                                  <input
                                    type="text"
                                    className="form-control p-2 "
                                    placeholder="Registration No"
                                    value={
                                      tractorType === "Others-N/A"
                                        ? registrationNo
                                        : isUpdate
                                          ? registrationNo
                                          : TractorRego
                                    }
                                    disabled={tractorType !== "Others-N/A"}
                                    onChange={(e) =>
                                      setRegistrationNo(e.target.value)
                                    }
                                  />

                                </div>

                                <div className="col-md-6 col-12 mt-2">
                                  <label
                                    for="exampleInputPassword1"
                                    className="form-label text-sm font-weight-600 mt-1"
                                  >
                                    Service{" "}
                                  </label>
                                  <div className="input-group input-group w-100">
                                    <input
                                      type="text"
                                      className="form-control p-2 "
                                      placeholder="Service"
                                      value={serviceId}
                                      onChange={handleServiceChange}
                                    />
                                  </div>

                                </div>
                                <div className="col-md-6 col-12 mt-2">
                                  <label
                                    for="exampleInputPassword1"
                                    className="form-label text-sm font-weight-600 mt-1"
                                  >
                                    Spares{" "}
                                  </label>
                                  <div className="input-group input-group w-100">
                                    <input
                                      type="text"
                                      className="form-control p-2 "
                                      placeholder="Spares"
                                      value={spares}
                                      onChange={handleSparesChange}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-6 col-12 mt-2">
                                  <label
                                    for="exampleInputPassword1"
                                    className="form-label text-sm font-weight-600 mt-1"
                                  >
                                    Meter Reading{" "}
                                  </label>
                                  <div className="input-group input-group w-100">
                                    <input
                                      type="number"
                                      className="form-control p-2 "
                                      placeholder="Meter Reading"
                                      value={meterReading}
                                      step="any"
                                      onChange={(e) =>
                                        setMeterReading(e.target.value)
                                      }
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6 col-12 mt-2">
                                  <label
                                    for="exampleInputPassword1"
                                    className="form-label text-sm font-weight-600 mt-1"
                                  >
                                    Fuel (In Liters){" "}
                                    <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <div className="input-group input-group w-100">
                                    <input
                                      type="number"
                                      className="form-control p-2 "
                                      placeholder="fuel"
                                      value={fuel}
                                      onChange={handlefuelChange}
                                    />
                                  </div>
                                  <span style={{ color: "red" }}>
                                    {Errorfuel}
                                  </span>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-6 col-12 mt-1">
                                  <label
                                    for="exampleInputPassword1"
                                    className="form-label text-sm font-weight-600 mt-1"
                                  >
                                    Cost <span style={{ color: "red" }}>*</span>{" "}
                                  </label>
                                  <div className="input-group input-group w-100">
                                    <input
                                      type="number"
                                      className="form-control p-2"
                                      placeholder="Cost"
                                      value={cost}
                                      onChange={handleCostChange}
                                    />
                                  </div>
                                  <span style={{ color: "red" }}>
                                    {errorcost}
                                  </span>
                                </div>

                                <div className="col-md-6 col-12 mt-2">
                                  <label
                                    htmlFor="exampleInputPassword1"
                                    className="form-label text-sm font-weight-600 mt-1"
                                  >
                                    Start Time <span style={{ color: "red" }}>*</span>
                                  </label>

                                  <div className="input-group input-group w-100">
                                    <DatePicker
                                      selected={
                                        startTime
                                          ? new Date(`1970-01-01T${startTime}`)
                                          : null
                                      }
                                      onChange={(time) =>
                                        handleStartTime({
                                          target: {
                                            value: time
                                              ? `${String(time.getHours()).padStart(2, "0")}:${String(
                                                time.getMinutes()
                                              ).padStart(2, "0")}`
                                              : "",
                                          },
                                        })
                                      }
                                      showTimeSelect
                                      showTimeSelectOnly
                                      timeIntervals={1}
                                      timeCaption="Time"
                                      dateFormat="hh:mm aa"
                                      placeholderText="Start Time"
                                      customInput={
                                        <CustomTimePickerInput placeholder="Start Time" />
                                      }
                                    />
                                  </div>

                                  <span style={{ color: "red" }}>{errstartTime}</span>
                                  <span style={{ color: "red" }}>{errorSTime}</span>
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-md-6 col-12 mt-2">
                                  <label
                                    htmlFor="exampleInputPassword1"
                                    className="form-label text-sm font-weight-600 mt-1"
                                  >
                                    End Time <span style={{ color: "red" }}>*</span>
                                  </label>

                                  <div className="input-group input-group w-100">
                                    <DatePicker
                                      selected={
                                        endTime
                                          ? new Date(`1970-01-01T${endTime}`)
                                          : null
                                      }
                                      onChange={(time) =>
                                        handleEndTime({
                                          target: {
                                            value: time
                                              ? `${String(time.getHours()).padStart(2, "0")}:${String(
                                                time.getMinutes()
                                              ).padStart(2, "0")}`
                                              : "",
                                          },
                                        })
                                      }
                                      showTimeSelect
                                      showTimeSelectOnly
                                      timeIntervals={1}
                                      timeCaption="Time"
                                      dateFormat="hh:mm aa"
                                      placeholderText="End Time"
                                      customInput={
                                        <CustomTimePickerInput placeholder="End Time" />
                                      }
                                    />
                                  </div>

                                  <span style={{ color: "red" }}>
                                    {errendTime}
                                  </span>
                                  <span style={{ color: "red" }}>
                                    {errorETime}
                                  </span>
                                </div>


                                <div className="col-md-6 col-12 mt-2">
                                  <label
                                    for="exampleInputPassword1"
                                    className="form-label text-sm font-weight-600 mt-1"
                                  >
                                    Remarks{" "}
                                  </label>
                                  <div className="input-group input-group w-100">
                                    <input
                                      type="text"
                                      className="form-control p-2"
                                      placeholder="Remarks"
                                      value={remarks}
                                      inputMode="text"
                                      onChange={handleRemarksChange}
                                    />
                                  </div>
                                </div>
                                <div className="col-md-6 col-12 mt-2">
                                  <label>
                                    Upload Image
                                    <input
                                      type="file"
                                      onChange={handleFileChange}
                                      multiple
                                    />{" "}
                                    <img
                                      src={UploadFile}
                                      style={{ height: 70 }}
                                      alt="Upload Preview"
                                    />{" "}
                                  </label>
                                  {profilePicUrlShow.map((url, index) => (
                                    <div key={index}>
                                      <img
                                        src={url}
                                        alt={`Selected ${index + 1}`}
                                        style={{
                                          maxHeight: "80px",
                                          maxWidth: "50%",
                                          border: "1px solid black",
                                        }}
                                      />
                                    </div>
                                  ))}
                                </div>
                              </div>{" "}
                              <br />
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                }}
                              >
                                <Button
                                  variant="primary"
                                  className="btnn"
                                  onClick={() => {
                                    setModalData({
                                      id: id,
                                      requiredDate: date,
                                      locationId: selectedLocation.code,
                                      locationName: selectedLocation,
                                      service: serviceId,
                                      tractorTypeId: tractorsID,
                                      spares: spares,
                                      fuel: fuel,
                                      startTime: startTime,
                                      endTime: endTime,
                                      cost: cost,
                                      remark: remarks,
                                      submittedDate: data,
                                      serverRecordId: "",
                                    });
                                    handleSubmit(modalData);
                                  }}
                                >
                                  {buttonText}
                                </Button>
                                <div style={{ width: "20px" }}></div>
                                <Button
                                  variant="danger"
                                  className="btnn"
                                  onClick={handleCancel_new}
                                >
                                  Cancel
                                </Button>
                              </div>
                            </Modal.Body>
                          </Modal>
                        </div>
                        <div>
                          <Modal
                            show={showPopup}
                            onHide={handleModalClose}
                            centered
                            backdrop="static"
                            keyboard={false}
                            size="ml"
                          >
                            <Modal.Header className="border-0 d-flex justify-content-center">
                              <Modal.Title>
                                {" "}
                                <span className="modal_title">Tractors</span>
                              </Modal.Title>
                              <Button
                                variant="link"
                                className="close btn btn-danger close_btn"
                                onClick={handleCancel}
                              >
                                X
                              </Button>
                            </Modal.Header>
                            <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                              <div className="d-flex justify-content-center mb-3 font-weight-600">
                                {showMsg ? (
                                  <p style={{ color: "#4A7729" }}>
                                    Are You Sure, Do You want close the Window ?
                                  </p>
                                ) : null}
                              </div>
                              <div className="d-flex justify-content-center">
                                <Button
                                  variant="primary"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleClose}
                                >
                                  Yes
                                </Button>
                                &nbsp;&nbsp;
                                <Button
                                  variant="danger"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleCancel}
                                >
                                  No
                                </Button>
                              </div>
                            </Modal.Body>
                          </Modal>
                        </div>
                        <div>
                          <Modal
                            show={showResponsePopup}
                            centered
                            backdrop="static"
                            keyboard={false}
                            size="ml"
                          >
                            <Modal.Header className="border-0 d-flex justify-content-center">
                              <Modal.Title>
                                {" "}
                                <span className="modal_title">Tractors </span>
                              </Modal.Title>
                              <Button
                                variant="link"
                                className="close btn btn-danger close_btn"
                                onClick={handleCancel}
                              >
                                X
                              </Button>
                            </Modal.Header>
                            <Modal.Body className="pl-md-5 pr-md-5 pt-0">
                              <div className="d-flex justify-content-center mb-3 font-weight-600">
                                {showMsg ? (
                                  <p style={{ color: "#4A7729" }}>
                                    {submitResponse}
                                  </p>
                                ) : null}
                              </div>
                              <div className="d-flex justify-content-center">
                                <Button
                                  variant="primary"
                                  className="d-flex justify-content-center cancel_button"
                                  onClick={handleresponse}
                                >
                                  Okay
                                </Button>
                                &nbsp;&nbsp;
                              </div>
                            </Modal.Body>
                          </Modal>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* ...End of Main Content...*/}

          {/* ...Footer...*/}
          <Footer />
          {/* ... End of Footer...  */}
        </div>
      </div>
      {/*  <!-- End of Page Wrapper -->

                    <!-- Scroll to Top Button--> */}
      <a className="scroll-to-top rounded" href="#page-top">
        <i className="fas fa-angle-up"></i>
      </a>

      {/*  <!-- Logout Modal--> */}
      <Logout />
    </body>
  );
};

export default FarmOperationsTractors;
